<template lang="pug">
  div
    table.table.table--bars
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.date' | translate }}
          th.table__cell {{ 'base.status' | translate }}
          th.table__cell {{ 'base.recipe' | translate }}
          th.table__cell {{ 'modals.ration_info.third' | translate }}
          th.table__cell {{ 'base.loading_time' | translate }}
      v-table-body(
        :cols="5"
        :loading="loading"
        :empty="!items.length")
        tr.table__row(
          v-for="item in items"
          :key="item.id"
          @click="onSelect(item)")
          td.table__cell {{ item.planned_on | date }}
          td.table__cell
            status-label(:status="item.status")
          td.table__cell {{ item.schedule_animalfeed_recipe.name }}
          td.table__cell {{ item.plan_weight | floor }} / {{ item.fact_weight | floor }}
          td.table__cell {{ timeLoad(item) }} {{ 'base.min' | translate }}
    v-dialog(
      :value="!!currentItem"
      @input="currentItem = null")
      mixer-loads-detail(
        :ingreds="currentItem"
        @on-close="currentItem = null")
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'
import { getDateForDatePicker } from '@/util'
import paginationMixin from '@/mixins/pagination.mixin'
import StatusLabel from '../../general-table/StatusLabel'
import MixerLoadsDetail from '../../mixer-loads/MixerLoadsDetail'

export default {
  name: 'KKZTable',

  components: {
    StatusLabel,
    UiPagination,
    MixerLoadsDetail
  },

  async mounted () {
    const farmId = this.$route.params.farm_id
    sessionStorage.removeItem(`reports_${farmId}_animalfeed`)
    this.watchFilters = false

    const hasDateFilters = this.filters.planned_on_before && this.filters.planned_on_after
    /* eslint-disable camelcase */
    const today = getDateForDatePicker(this.timezone)
    const planned_on_before = hasDateFilters ? this.filters.planned_on_before : today
    const planned_on_after = hasDateFilters ? this.filters.planned_on_after : today

    const baseFilters = {
      planned_on_before,
      planned_on_after,
      farm: farmId
    }
    /* eslint-enable camelcase */
    const fullFilters = hasDateFilters
      ? {
        ...baseFilters,
        group: [],
        animal_type: [],
        ration: [],
        loading: [],
        status: [],
        loaded_time_max: null,
        loaded_time_min: null
      }
      : baseFilters

    this.$store.dispatch('reports/applyFilters', fullFilters)

    await this.setupPagination(
      api.reports.animalfeed.list,
      {
        ...baseFilters,
        page: this.page > 1 ? this.page : 1
      },
      `reports_${farmId}_animalfeed`
    )
    this.$store.dispatch('reports/applyTotal', this.pageCount)
    this.watchFilters = true
  },
  data: () => ({
    loaded: false,
    currentItem: null,
    watchFilters: true
  }),
  mixins: [paginationMixin],
  methods: {
    ...mapActions('kkzreports', [
      'loadReports'
    ]),

    onSelect (item) {
      if (item.load_trackers[0] !== undefined) {
        let data = item.load_trackers[0].schedule_ingredients
        this.currentItem = data.map(i => ({
          ...i,
          worker: item.load_trackers[0].worker.name
        }))
      } else {
        this.currentItem = []
      }
    },
    timeLoad (item) {
      if (!item || !Array.isArray(item.load_trackers) || item.load_trackers.length === 0) {
        return item && item.mix_time ? item.mix_time : 0
      }

      const scheduleIngredients = item.load_trackers[0].schedule_ingredients || []
      let totalTimeLoad = 0

      for (let ingredient of scheduleIngredients) {
        totalTimeLoad += ingredient.time_load || 0
      }

      return Math.round(totalTimeLoad / 60)
    }
  },

  computed: {
    ...mapGetters('reports', [
      // 'load',
      'filters',
      // 'totalCount'
    ]),
    ...mapGetters('kkzreports', [
      // 'filters',
      'reports'
    ]),
    timezone () {
      return this.$store.getters['account/timezone']
    },
  },
  watch: {
    filters: {
      async handler () {
        if (this.watchFilters) {
          await this.$router.push({
            query: {
              ...this.$route.query,
              page: 1
            }
          })
          if (!this.filters.planned_on_before && !this.filters.planned_on_after) {
            const today = getDateForDatePicker(this.timezone)
            this.$store.dispatch('reports/applyFilters', {
              planned_on_before: today,
              planned_on_after: today,
              farm: this.$route.params.farm_id
            })
          }
          await this.setupPagination(
            api.reports.animalfeed.list,
            {
              farm: this.$route.params.farm_id,
              ...this.filters,
              page: 1
            },
            `reports_${this.$route.params.farm_id}_animalfeed`
          )
          this.$store.dispatch('reports/applyTotal', this.pageCount)
        }
      },
      deep: true
    }
  }
}
</script>
